import I18n from 'i18n-js';
import React from 'react';
import giftCardImgSrc from '../../../../images/sidebar/gift-card-sidebar-promo.png';
import shippingImgSrc from '../../../../images/sidebar/shipping-resources.jpg';
import { US_CON_CODE } from '../../shared/constants';

const ShippingResourcesAd = () => (
  <a
    className="sidebar-promo sidebar-promo--shipping-resources"
    href="/selling/shipping-resources"
  >
    <h4 className="sidebar-promo__heading">
      {I18n.t('discovery.sidebarAds.shippingResources')}
    </h4>
    <p className="sidebar-promo__subheading">
      {I18n.t('discovery.sidebarAds.shippingResourcesSubhead')}
    </p>
    <img
      className="sidebar-promo__image"
      src={shippingImgSrc}
      alt={I18n.t('discovery.sidebarAds.shippingResources')}
    />
    <p className="sidebar-promo__footer">
      <span className="angle-double-right">
        {I18n.t('discovery.sidebarAds.learnMore')}
      </span>
    </p>
  </a>
);

const GiftCardAd = () => (
  <a
    className="sidebar-promo sidebar-promo--gift-card"
    href="/gift-cards"
  >
    <h4 className="sidebar-promo__heading">
      {I18n.t('discovery.sidebarAds.giftCardsEasier')}
    </h4>
    <img
      className="sidebar-promo__image"
      src={giftCardImgSrc}
      alt={I18n.t('discovery.sidebarAds.shopGiftCards')}
    />
    <p className="sidebar-promo__footer">
      <span className="angle-double-right">
        {I18n.t('discovery.sidebarAds.shopGiftCards')}
      </span>
    </p>
  </a>
);

const SidebarAds = ({ region = null }) => (
  <div className="sidebar-promos">
    <ShippingResourcesAd />
    {[US_CON_CODE, 'US_AK', 'US_HI'].includes(region) && <GiftCardAd />}
  </div>
);

export default SidebarAds;
